import { CommonModule } from '@angular/common';
import {
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  Output,
  ViewChild,
} from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { Subscription } from 'rxjs';
import { ProposalService } from 'src/app/_services/proposal.service';
import { ProposalDetails } from 'src/app/_types/proposals.type';
import { PolicyStatus } from 'src/app/enums/proposal.enums';

import { ActionModalComponent } from '../action-modal/action-modal.component';

@Component({
  selector: 'app-update-policy-status-modal',
  standalone: true,
  imports: [CommonModule, ActionModalComponent],
  templateUrl: './policy-status-update-modal.component.html',
})
export class UpdatePolicyStatusModal implements OnDestroy {
  @Input() policy: ProposalDetails;

  @Input() status: PolicyStatus;

  @Input() titleText: string;

  @Output() updateSuccess = new EventEmitter();

  @Output() updatedFail = new EventEmitter();

  @Output() updateCancel = new EventEmitter();

  submitted = false;

  subscription: Subscription;

  @ViewChild('actionModal') modal: ActionModalComponent;

  constructor(
    private readonly proposalService: ProposalService,
    private readonly toastrService: ToastrService
  ) {}

  updatePolicyStatus() {
    if (this.submitted || !this.policy) return;
    this.submitted = true;
    this.subscription = this.proposalService
      .updatePolicyStatus({
        policyStatus: this.status,
        proposalId: this.policy.proposalId,
      })
      .subscribe({
        next: () => {
          this.toastrService.success($localize`Statut mis à jour avec succès`);
          if (this.modal) this.modal.closeModal();
          this.updateSuccess.emit();
          this.submitted = false;
        },
        error: () => {
          this.toastrService.error(
            $localize`Une erreur est survenue. Veuillez réessayer`
          );
          this.submitted = false;
        },
      });
  }

  ngOnDestroy(): void {
    if (this.subscription) this.subscription.unsubscribe();
  }
}
